// src/componance/PropertyImagesModal.js
import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PropertyImagesModal = ({ images, propertyName, onClose }) => {
  const maxDots = 5;

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000, // 2 วิ ต่อสไลด์
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    lazyLoad: "ondemand", 
    appendDots: (dots) => {
      const total = dots.length;
      const visibleDots = total > maxDots ? dots.slice(0, maxDots) : dots;

      return (
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ul
            style={{
              margin: 2,
              paddingLeft: "15px",
              background: "rgba(0, 0, 0, 0.4)",
              borderRadius: "12px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center", // ✅ จัดจุดให้อยู่กลางแนวตั้งของพื้นหลัง
              gap: "5px",
              minHeight: "18px", // ✅ ให้กรอบดำมีความสูงพอดีจุด
            }}
          >
            {visibleDots.map((dot, i) => (
              <li
                key={i}
                style={{
                  listStyle: "none",
                  display: "flex",
                  alignItems: "center", // ✅ จัดให้อยู่กลางของ li
                }}
              >
                <div
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    background: "white",
                    opacity: dot.props.className.includes("slick-active") ? 1 : 0.5,
                    transition: "opacity 0.3s",
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
      );
    },
  };

  if (!images || images.length === 0) return null;

  return (
    <div onClick={onClose}>
      <div
        style={{ width: '100%', height: '100%', position: 'relative' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={styles.imageContainer}>
          <img src="/img/logo3.png" alt="Logo" style={styles.logoUnderId} />

          {images.length > 1 ? (
            <Slider {...sliderSettings} style={{ width: '100%', height: '100%' }}>
              {images.map((img, idx) => (
                <div key={idx} style={styles.slideBox}>
                <a
                  href={img}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "block",
                    width: "100%",
                    height: "100%",
                    WebkitTouchCallout: "default", // ✅ ให้ Safari แสดงเมนูเมื่อกดค้าง
                    WebkitUserSelect: "auto",      // ✅ อนุญาตให้แตะรูปได้
                    pointerEvents: "auto",         // ✅ ป้องกัน overlay ปิดการแตะ
                  }}
                >
                  <img
                    src={img}
                    alt={`${propertyName || "Property"} ${idx + 1}`}
                    style={{
                      ...styles.image,
                      WebkitTouchCallout: "default", // ✅ แสดงเมนู "Save Image"
                      WebkitUserSelect: "auto",
                      pointerEvents: "auto",
                    }}
                     loading="lazy" // ✅ เพิ่มตรงนี้
                  />
                </a>
              </div>

              ))}
            </Slider>
          ) : (
            <div style={styles.slideBox}>
              <img
                src={images[0]}
                alt={propertyName || 'Property'}
                style={styles.image}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  imageContainer: {
    position: 'relative',
  },
  slideBox: {
    width: '100%',
    aspectRatio: '16/9', // คงเป็นแนวนอนเสมอ
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000',
    borderRadius: '8px',
    margin: 'auto',
  },
  image: {
    width: '100%',
    height: '42.65vh',
    objectFit: 'cover', // ✅ ซูมครอปให้เต็มเฟรม
    
  },
  logoUnderId: {
    position: 'absolute',
    top: '20px',
    left: '10px',
    width: '100px',
    height: 'auto',
    zIndex: 999,
  },
};

export default PropertyImagesModal;
